import React from 'react'
import SarasTrans from '../../../../library/notifications/SarasTrans';

const DocPriority =(props)=>{
    const {formObject, viewData} = props;

    const valCssClass = formObject.getValueFromKey(viewData, "dataList.valCssClass", "");
    const priorityClass = formObject.getValueFromKey(viewData, "dataList.priorityClass", "");

    // console.log("priority", viewData, valCssClass);

    return (
        <div className="saras-cell">
            <span className={`uiPriority ${valCssClass} ${priorityClass}`}><SarasTrans value = {viewData.dataList.valS}/></span>
        </div>
    )
}

export default DocPriority